<script>
export default {
	name: 'Footer Copyright',
	data: () => {
		return {
			copyrightDate: new Date().getFullYear(),
			projectName: 'Ouderraad Loppem Webshop',
			author: 'Coony',
		};
	},
};
</script>

<template>
	<div class="print:hidden flex justify-center items-center text-center">
		<div
			class="font-general-regular text-lg text-ternary-dark dark:text-ternary-light"
		>
			&copy; {{ copyrightDate }}.
			<a
				href="https://ouderraadloppem.be"
				target="__blank"
				class="font-general-medium hover:underline hover:text-indigo-600 dark:hover:text-indigo-300 duration-500"
			>
				{{ projectName }}
			</a>
			. Developed by
			<a
				href="https://coony.be"
				target="__blank"
				class="font-general-medium text-secondary-dark dark:text-secondary-light uppercase hover:underline hover:text-indigo-600 dark:hover:text-indigo-300 duration-500"
				>{{ author }}</a
			>
		</div>
		
	</div>
	<div class="flex justify-center items-center text-center">
		<div class="font-general-regular text-sm text-gray-400 mt-4">version: {{ this.$store.getters['core/appVersion'] }}</div>
	</div>
</template>

<style lang="scss" scoped></style>
